import {defineStore, storeToRefs} from 'pinia'
import { ref } from "vue";
import { useStatesStore } from "@/store/states.js";
import { useRouter } from "vue-router";
import { useAgencyTheme } from "@/composables/AgencyTheme.js";

export const useUserStore = defineStore('user', () => {
    const router = useRouter();
    const user = ref(null);
    const statesStore = useStatesStore();
    const { loading, validationErrors } = storeToRefs(statesStore);
    const { setTheme } = useAgencyTheme();

    const fetch = async () => {
        try {
            const response = await axios.get('/api/user');
            user.value = response.data.data;

        } catch (e) {
            user.value = null;
        }

        setTheme(user.value);
    };

    const logout = async () => {
        try {
            await axios.post('/api/logout');
        } catch (error) {
            //
        }

        user.value = null;
        await router.push({ name: 'login' });
    };

    const register = async (payload, callback) => {
        loading.value = true;

        try {
            await axios.post('/api/register', payload)
            await statesStore.onSuccess();
            callback()
        } catch (error) {
            await statesStore.onFail();
            validationErrors.value = error.response.data.errors;
        }
    };

    const update = async (payload) => {
        loading.value = true;

        try {
            const { data } = await axios.put('/api/user', payload)
            user.value = data.data;

            await statesStore.onSuccess();
        } catch (error) {
            await statesStore.onFail();
            validationErrors.value = error.response.data.errors;
        }
    };

    const forgotPassword = async (payload, onSuccess) => {
        loading.value = true;

        try {
            await axios.post('/api/forgot-password', payload)
            await statesStore.onSuccess();
            onSuccess();
        } catch (error) {
            await statesStore.onFail();
            validationErrors.value = error.response.data.errors;
        }
    };

    const resetPassword = async (payload, onSuccess) => {
        loading.value = true;

        try {
            await axios.post('/api/reset-password', payload)
            await statesStore.onSuccess();
            onSuccess();
        } catch (error) {
            await statesStore.onFail();
            validationErrors.value = error.response.data.errors;
        }
    };

    return {
        user,
        fetch,
        logout,
        register,
        forgotPassword,
        resetPassword,
        update,
    };
});
